import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TechiesBaseAcademy from './TechiesBaseAcademy';
import DevOpsInterviewQAPage from './pages/DevOpsInterviewQAPage';
import AWSVPComponent from './components/AWSVPComponent';
import DevOpsTools from './components/DevOpsTools';
import VLSMCalculator from './components/CIDRVLSMComponent';
import AWSArchitectureGuide from './components/aws_architecture_guide';
import NetworkLayersExplorer from './components/network-layers-component';

const App = () => {
  return (
    <div className="min-h-screen bg-gray-900">
      <Router>
        <Routes>
          <Route path="/" element={<TechiesBaseAcademy />} />
          <Route path="/devops-interview-qa" element={<DevOpsInterviewQAPage />} />
          <Route path="/aws-vpc-component" element={<AWSVPComponent />} />
          <Route path="/devops-tools" element={<DevOpsTools />} />
          <Route path="/vlsm-calculator" element={<VLSMCalculator />} />
          <Route path="/aws-regions-azs" element={<AWSArchitectureGuide />} />
          <Route path="/network-layers" element={<NetworkLayersExplorer />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
